const fileList = () => import("@/pages/file/list/index.vue");
const fileListForm = () => import("@/pages/file/list/form.vue");
const fileListDetail = () => import("@/pages/file/list/detail.vue");

export default [
    {
        path: "/file/list",
        component: fileList,
        meta: [
            {
                name: "文件管理",
                activeRoute: "/file/manage",
            },
            {
                name: "文件列表",
                activeRoute: "/file/list",
            },
        ],
    },
    {
        path: "/file/list/form",
        component: fileListForm,
        meta: [
            {
                name: "文件管理",
                activeRoute: "/file/manage",
            },
            {
                name: "文件列表",
                url: "/file/list",
            },
            {
                name: "新增/编辑",
                activeRoute: "/file/list",
            },
        ],
    },
    {
        path: "/file/list/detail",
        component: fileListDetail,
        meta: [
            {
                name: "文件管理",
                activeRoute: "/file/manage",
            },
            {
                name: "文件列表",
                url: "/file/list",
            },
            {
                name: "文件详情",
                activeRoute: "/file/list",
            },
        ],
    },
];
